/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import ScrollMenu from 'react-horizontal-scrolling-menu';
// import { stubTrue } from "lodash";
//import StepItem from '../../components/StepItem'

class LiveInfoNew extends PureComponent {
  state = {
    left: false,
    right: true,
  };
  _isMounted = false;
  interval = null;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    //console.log(contentSerial)
    this._getData(contentSerial);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.subTitle !== nextProps.childProps.subTitle;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.subTitle !== nextProps.childProps.subTitle) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };
  _getData = async (contentSerial) => {
    const { existLive } = this.props.childProps;
    const result = await this._getDataApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const str = result.data[0].str;
    const nextLiveInfo = result.data[0].listData;
    //console.log(contentSerial)
    //console.log(str)
    //console.log(nextLiveInfo)
    //console.log('=====================>다시불러옴.')
    if (this._isMounted) {
      if (intReturn === 0) {
        this.setState({
          str,
          nextLiveInfo,
        });
      } else {
        this.setState({
          str,
        });
      }
      ////console.log(str, intReturn)

      if (str !== '') {
        if (intReturn === 0) {
          existLive(true);
        } else {
          existLive(true);
        }
      } else {
        if (intReturn === 0) {
          existLive(true);
        } else {
          existLive(false);
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/contentLiveInfo', {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { nextLiveInfo } = this.state;

    const list = nextLiveInfo.map((item, index) => {
      return (
        <li key={index}>
          <div>
            <p className="date">
              {item.mm}.{item.dd} ({item.weekName}) {item.startTime}
            </p>
            <p className="epi">{item.subTitle}</p>
          </div>
        </li>
      );
    });

    return list;
  };
  _onFirst = () => {
    this.setState({
      left: false,
      right: true,
    });
  };
  _onLast = () => {
    this.setState({
      right: false,
      left: true,
    });
  };
  _toggleAlram = () => {
    const { toggleAlram } = this.props.childProps;
    toggleAlram();
  };
  render() {
    const { str, nextLiveInfo, left, right } = this.state;
    const { alram } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="info">
          <div className="live active">
            <dl>
              <dt>본방</dt>
              <dd>
                <button
                  type="button"
                  className={alram === 100 ? 'btn_bell active' : 'btn_bell'}
                  title="알림"
                  onClick={this._toggleAlram}
                >
                  알림{alram}
                </button>
                {str}
                {/*매주(금) 23:30 - 25화 달 아래에서, 엉터리 댄스를*/}
              </dd>
            </dl>
          </div>
          {nextLiveInfo ? (
            <div className="timeline">
              <dl>
                <dt>재방</dt>
                <dd>
                  <ul className="list">
                    {nextLiveInfo ? (
                      <ScrollMenu
                        data={nextLiveInfo ? this._renderItem() : null}
                        arrowLeft={
                          left ? (
                            <div className="btn_prev">
                              <img
                                src={imgUrl + '/img/live_img/arrow_lt.png'}
                              />
                            </div>
                          ) : null
                        }
                        arrowRight={
                          right ? (
                            <div className="btn_next">
                              <img
                                src={imgUrl + '/img/live_img/arrow_rt.png'}
                              />
                            </div>
                          ) : null
                        }
                        wheel={false}
                        dragging={true}
                        transition={0.5}
                        translate={0}
                        alignOnResize={true}
                        //inertiaScrolling={true}
                        //inertiaScrollingSlowdown={3}
                        //wrapperStyle={{border: 0, backgroundColor: '#fff'}}
                        itemStyle={{
                          borderLeftStyle: 'inset',
                          borderLeftWidth: 1,
                          borderLeftColor: '#888',
                        }}
                        alignCenter={false}
                        hideSingleArrow={true}
                        hideArrows={false}
                        onFirstItemVisible={this._onFirst}
                        onLastItemVisible={this._onLast}
                      />
                    ) : null}
                  </ul>
                </dd>
              </dl>
            </div>
          ) : null}
        </div>

        {/*
                <div className="timelineliveinfo">
                    {str === '' || str === undefined || str === null ? null : (
                         <div className="bo">
                            <span>본방</span> {str}
                        </div>
                    )}
                   
                    { nextLiveInfo ? (
                        <div className="jae">
                            <span className="">재방</span> {this._renderItem()}
                        </div>
                    ) : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(LiveInfoNew)));
